<ion-content class="ion-padding ion-text-center">
  {{ message }}
</ion-content>
